<template>
	<div id="app">
		<div id="nav">
			<Header />
		</div>
		<keep-alive :include="keepAlive">
			<router-view />
		</keep-alive>
	</div>
</template>

<script>
import Header from './components/Header/Header.vue';
export default {
	components: {
		Header
	},
	computed: {
		keepAlive() {
			return this.$store.getters.keepAlive;
		}
	},
	created() {
		this.$store.dispatch('getProductList');
	}
};
</script>

<style lang="scss">
@use './common/css/base.scss';
#app {
	width: 100%;
	height: 100%;
	position: relative;
}
</style>
